export const FUNNELED_RULES = {
  // SCREEN FUNNELED EVENTS
  PET_SCREEN_ENTRY_FUNNELED: 'PetScreenEntryFunneled',
  PET_SCREEN_ENTRY_WITH_SALES_PARTNER_NUMBER_FUNNELED: 'PetScreenEntryWithSalesPartnerNumberFunneled',
  PET_SCREEN_REENTRY_FUNNELED: 'PetScreenReentryFunneled',
  PET_SCREEN_PET_DETAILS_FUNNELED: 'PetScreenPetDetailsFunneled',
  PET_SCREEN_HEALTH_QUESTIONS_FUNNELED: 'PetScreenHealthQuestionsFunneled',
  PET_SCREEN_HEALTH_QUESTIONS_EXTENDED_FUNNELED: 'PetScreenHealthQuestionsExtendedFunneled',
  PET_SCREEN_HEALTH_QUESTIONS_DECLINED_FUNNELED: 'PetScreenHealthQuestionsDeclinedFunneled',
  PET_SCREEN_PRODUCTS_SELECTION_FUNNELED: 'PetScreenProductsSelectionFunneled',
  PET_SCREEN_OVERVIEW_FUNNELED: 'PetScreenOverviewFunneled',
  PET_SCREEN_SUBMIT_FUNNELED: 'PetScreenSubmitFunneled',
  PET_SCREEN_SUCCESS_FUNNELED: 'PetScreenSuccessFunneled',
  PET_SCREEN_UNSUBSCRIBE_FUNNELED: 'PetScreenUnsubscribeFunneled',
  // ACTIONS FUNNELED EVENTS
  PET_MODAL_OPENED_FUNNELED: 'PetModalOpenedFunneled',
  PET_SUMMARY_SENT_FUNNELED: 'PetSummarySentFunneled'
}

export const RULES = {
  ...FUNNELED_RULES,
  PET_ENTERED: 'PetEntered',
  PET_DEDUCTIBLE_CHANGED: 'PetDeductibleChanged',
  PET_GO_TO_SANITAS_CLICKED: 'PetGoToSanitasClicked',
  PET_NEW_PET_CLICKED: 'PetNewPetClicked',
  PET_PAGE_VIEWED: 'PetPageViewed',
  PET_PRODUCT_ADDED: 'PetProductAdded',
  PET_SELECTED: 'PetSelected',
  PET_MODAL_CLOSE: 'PetModalClose'
}
